import { xcss } from '@atlaskit/primitives';

export const container = xcss({
  borderStyle: 'solid',
  borderWidth: 'border.width',
  borderColor: 'color.border',
  // @ts-ignore
  borderRadius: 8, // need to check why border tokens are not getting defined as CSS vars
});
